module.exports = __webpack_public_path__ + "static/media/IMG_015.c83b7130.JPG";